import React from 'react';
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <div className="bg-gradient-to-r from-blue-900 to-blue-400 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-4">
            LEGAL
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            How RDS Group of Colleges protects and manages your information
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8">
          <div className="border-b border-gray-200 pb-4 flex justify-between items-center">
            <p className="text-gray-600">Last Updated: March 17, 2026</p>
            <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-xs font-semibold">Effective</span>
          </div>
          
          <div className="bg-orange-50 p-6 rounded-xl">
            <p className="text-gray-700 leading-relaxed">
              At RDS Group of Colleges, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or interact with our educational institutions.
            </p>
          </div>
            <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              1. Information We Collect
            </h2>
            <div className="pl-6 space-y-3">
              <p className="text-gray-700 leading-relaxed">
                We collect information that you voluntarily provide to us when you:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Fill out admission forms (online or offline)</li>
                <li>Register for courses or programs</li>
                <li>Contact us via email, phone, or our website</li>
                <li>Visit our campus and provide visitor information</li>
                <li>Participate in college events or surveys</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-2">
                This information may include your name, email address, phone number, postal address, date of birth, educational qualifications, photographs, and payment information.
              </p>
            </div>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              2. How We Use Your Information
            </h2>
            <div className="pl-6 space-y-3">
              <p className="text-gray-700 leading-relaxed">
                We use the information we collect for various purposes, including to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Process your admissions and maintain academic records</li>
                <li>Communicate with you about your application, enrollment, and academic progress</li>
                <li>Send you important updates about the college, events, and academic calendars</li>
                <li>Improve our educational services and student experience</li>
                <li>Comply with legal obligations and regulatory requirements</li>
                <li>Protect the security and integrity of our college</li>
              </ul>
            </div>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              3. Sharing Your Information
            </h2>
            <div className="pl-6 space-y-3">
              <p className="text-gray-700 leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may share your information with:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><span className="font-semibold">Affiliated Universities:</span> Veer Bahadur Singh Purvanchal University, Jaunpur and AKTU Lucknow for academic purposes</li>
                <li><span className="font-semibold">Government Bodies:</span> As required by law or regulatory requirements</li>
                <li><span className="font-semibold">Service Providers:</span> Who assist us in operating our college and conducting our programs</li>
              </ul>
            </div>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              4. Data Security
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These include secure servers, firewalls, and encrypted data transmission. However, no method of transmission over the Internet or electronic storage is 100% secure.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              5. Your Rights
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              You have the right to access, correct, or delete your personal information held by us. You may also object to or restrict certain processing of your information. If you wish to exercise these rights, please contact us using the information provided below.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              6. Cookies and Tracking Technologies
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can set your browser to refuse all or some cookies, but this may affect your ability to use certain features of our website.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-800 flex items-center">
              <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
              7. Changes to This Privacy Policy
            </h2>
            <p className="text-gray-700 leading-relaxed pl-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page with an updated effective date. We encourage you to review this Privacy Policy periodically.
            </p>
          </div>
          <div className="mt-8 bg-gradient-to-r from-orange-50 to-blue-50 p-6 rounded-xl border border-orange-200">
            <h3 className="text-xl font-bold text-blue-800 mb-4 flex items-center">
              <svg className="w-5 h-5 text-orange-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              Contact Us Regarding Privacy
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600">Email</p>
                <a href="mailto:rdscollege342@gmail.com" className="text-blue-800 hover:text-orange-600 font-medium">rdscollege342@gmail.com</a>
              </div>
              <div>
                <p className="text-sm text-gray-600">Phone</p>
                <p className="text-blue-800 font-medium">7275370808, 9628362187</p>
              </div>
              <div className="md:col-span-2">
                <p className="text-sm text-gray-600">Address</p>
                <p className="text-blue-800 font-medium">Kusanw Bhaupur, Jaunpur, UP-222136 (Near Trilochan Mahadev)</p>
              </div>
            </div>
          </div>
          <div className="text-center text-sm text-gray-500 pt-4 border-t border-gray-200">
            <p>© 2026 RDS Group of Colleges. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;